import { render, staticRenderFns } from "./event-info.html?vue&type=template&id=7fb7a772&scoped=true&external"
import script from "./event-info.js?vue&type=script&lang=js&external"
export * from "./event-info.js?vue&type=script&lang=js&external"
import style0 from "./event-info.scss?vue&type=style&index=0&id=7fb7a772&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7a772",
  null
  
)

export default component.exports